export default __webpack_public_path__ + "static/media/c4.f3f48c02.jpeg";